<template>
  <section class="termo-aceite">
    <h4 class="h4 color-blue font-weight-bold">Aceite do Termo Aditivo</h4>
    <Aceite
      :voltar="voltar"
      :action-voltar="true"
      :action-aceite="true"
      @click="salvarAceite"
      @fechar="fechar"
      :file="file"
      :aceite="aceite"
      :loading="loading"
      :strLoading="'Aguarde, salvando termo'"
    />
  </section>
</template>
<script>
import Aceite from "@/components/aceite/Aceite.vue";
export default {
  name: "TermoAceite",
  components: {
    Aceite,
  },
  props: {
    cpfTitular: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      voltar: true,
      loading: false,
      linkVoltar: "#",
      linkAceite: "#",
      aceite: "Estou de acordo com o termo acima.",
      file: null,
    };
  },
  methods: {
    salvarAceite(payload) {
      this.loading = true;
      this.$emit("click", {
        checkAceite: payload.checkAceite,
      });
    },
    fechar() {
      this.$emit("fechar");
    },
  },
  created() {
    this.$http
      .get(`/api/Drive/BuscarTermoSaude?cpfTitular=${this.cpfTitular}`)
      .then((response) => {
        this.file = `data:application/pdf; base64, ${response.data.file.fileContents}`;
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>
